// extracted by mini-css-extract-plugin
var _1 = "input__o0xV_";
var _2 = "input-active__G6f6e";
var _3 = "placeholder__abCJb";
export { _1 as "input", _2 as "inputActive", _3 as "placeholder" }
